import UnderConstruction from "@/components/common/UnderConstruction";

const ReportPage = () => {
  return <UnderConstruction />;
};

export default ReportPage;
